{ 
  filename = "__base__/graphics/entity/TODO\OUTPUT/hr-boiler-E-patch.png",
  line_length = 1,
  width = 6,
  height = 36,
  frame_count = 1,
  axially_symmetrical = false,
  direction_count = 1,
  shift = util.by_pixel(33.5, -13.5)
}